import { useCallback, useMemo, useState } from 'react'

import { useUser } from '@/modules/auth'
import { loadTrialTourSeenAt, persistTrialTourSeenAt } from './prefs'

// Until the user is known the tour counts as seen, so it never starts by mistake.
export const useTrialTourSeen = () => {
  const userId = useUser()?.id ?? null
  const [finishedFor, setFinishedFor] = useState<string | null>(null)
  const seenBefore = useMemo(
    () => userId === null || loadTrialTourSeenAt(userId) !== null,
    [userId],
  )

  const markSeen = useCallback(() => {
    if (userId === null) return
    persistTrialTourSeenAt(userId, new Date().toISOString())
    setFinishedFor(userId)
  }, [userId])

  return { seen: seenBefore || finishedFor === userId, markSeen }
}
